import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type {
  RequestResetPayload,
  ResetPasswordPayload,
  VerifyOtpPayload,
} from "./types";

export interface PasswordResetState {
  email: string | null;
  requestReset: { saving: boolean; error: boolean };
  verifyOtp: { saving: boolean; error: boolean; verified: boolean };
  resetPassword: { saving: boolean; error: boolean; success: boolean };
}

export const initialState: PasswordResetState = {
  email: null,
  requestReset: { saving: false, error: false },
  verifyOtp: { saving: false, error: false, verified: false },
  resetPassword: { saving: false, error: false, success: false },
};

export const passwordResetSlice = createSlice({
  name: "passwordReset",
  initialState,
  reducers: {
    saveRequestReset(state, { payload }: PayloadAction<RequestResetPayload>) {
      state.email = payload.email;
      state.requestReset.saving = true;
      state.requestReset.error = false;
      state.verifyOtp.verified = false;
    },
    requestResetSaved(state) {
      state.requestReset.saving = false;
      state.requestReset.error = false;
    },
    requestResetSavingError(state) {
      state.requestReset.saving = false;
      state.requestReset.error = true;
    },

    saveVerifyOtp(state, _action: PayloadAction<VerifyOtpPayload>) {
      state.verifyOtp.saving = true;
      state.verifyOtp.error = false;
    },
    verifyOtpSaved(state) {
      state.verifyOtp.saving = false;
      state.verifyOtp.error = false;
      state.verifyOtp.verified = true;
    },
    verifyOtpSavingError(state) {
      state.verifyOtp.saving = false;
      state.verifyOtp.error = true;
      state.verifyOtp.verified = false;
    },

    saveResetPassword(state, _action: PayloadAction<ResetPasswordPayload>) {
      state.resetPassword.saving = true;
      state.resetPassword.error = false;
    },
    resetPasswordSaved(state) {
      state.resetPassword.saving = false;
      state.resetPassword.error = false;
      state.resetPassword.success = true;
    },
    resetPasswordSavingError(state) {
      state.resetPassword.saving = false;
      state.resetPassword.error = true;
    },

    resetFlow() {
      return initialState;
    },
  },
});

export const {
  saveRequestReset,
  requestResetSaved,
  requestResetSavingError,
  saveVerifyOtp,
  verifyOtpSaved,
  verifyOtpSavingError,
  saveResetPassword,
  resetPasswordSaved,
  resetPasswordSavingError,
  resetFlow,
} = passwordResetSlice.actions;

export const { reducer } = passwordResetSlice;
